var _this = this;

import { getMe } from '../generated';
export var getMeExtended = function getMeExtended(api, pelotonPlatform) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return getMe.apply(_this, [api, pelotonPlatform, options]);
};